import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { showToast } from 'utils/utility';
import { useAdminData } from 'libs/data-access';

export default function useAdminAccounts() {

    const navigate = useNavigate();

    const { getAdminData } = useAdminData();


    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [accountList, setAccountList] = useState<IAccounts[]>([]);


    useEffect(() => {
        getAccountList();
    }, []);


    // API CALLS
    const getAccountList = async () => {
        setIsLoading(true);

        const response = await getAdminData("/bank-details");

        if (response.isSuccess) {
            // console.log("Response for getting account list: ", response.data?.data);
            setAccountList(response.data?.data);
        } else {
            console.log("Error while getting account list: ", response.message);
            showToast({
                type: "error",
                message: response.message || "Error while getting account list!"
            });
        };

        setIsLoading(false);
    };


    return {
        navigate,
        isLoading,
        accountList
    };

};

interface IAccounts {
    userId: number;
    bankName: string | null;
    bankAddress: string | null;
    branch: string | null;
    systemCode: string | null;
    accountNumber: string | null;
    accountName: string | null;
    challanId: number | null;
    ifsccode: string | null;
    micnumber: string | null;
};